import { TableRowTypes } from "./types"

const TableRow = ({ className, onClick, children }: TableRowTypes) => (
  <tr className={className} onClick={onClick}>
    {children}
  </tr>
)

export default TableRow
